<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicant"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.transferElDocsStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Прошу передать электронный документ (пакет электронных документов) и
          выдать свидетельство о направлении/ передаче электронного документа
          (пакета электронных документов):
        </div>
        <div>
          <Step2 :data="statement.transferElDocsStep2" />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.transferElDocsStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>
        <div>
          <StepRequisites
            :data="statement.transferElDocsStep3"
            :statement-type="StatementType.TRANSFER_EL_DOCS"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>
        <div>
          <StepSign :data="statement.locationStep" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/TransferElDocs/Step2';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'TransferElDocs',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    StepSign,
    StepRequisites,
    Subject,
    Step2,
  },
  data: () => ({
    StatementType,
  }),
};
</script>

<style scoped></style>
